(($) => {
    $(document).on('ready', init);

    function init() {
        bind();
    }

    function bind() {
        $('html').on('bb-lumeris:lum-icon-blocks:init', moduleInit);
    }

    function moduleInit(event, data) {
        if (!event || !data) {
            return false;
        }

        const $module = $(`.fl-node-${data.node}`);
        moduleBind();

        function moduleBind() {

        }
    }
})(jQuery);